import { useQuery } from '@tanstack/react-query';
import { cdfService } from 'v2/services/cdfService';

export const useLoadItems = (id: number) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['cdf', 'loadItems', id],
    queryFn: () => cdfService.getDetailsItems(id),
    enabled: !!id
  });

  return {
    items: data?.data ?? [],
    isLoading,
    error
  };
};
